(() => {
  const styleId = 'dd-hide-pop-convert-trigger';
  const styleText = `
    .button-container-left,
    .button-container-right,
    .button-container-bottom {
      display: none !important;
    }
  `;
  let observedShadowRoot;
  let shadowObserver;

  const hideTrigger = () => {
    const shadowRoot = document.querySelector('#pop-convert-app')?.shadowRoot;

    if (!shadowRoot) return false;

    let style = shadowRoot.getElementById(styleId);

    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      shadowRoot.append(style);
    }

    if (style.textContent !== styleText) {
      style.textContent = styleText;
    }

    if (observedShadowRoot !== shadowRoot) {
      shadowObserver?.disconnect();
      observedShadowRoot = shadowRoot;
      shadowObserver = new MutationObserver(hideTrigger);
      shadowObserver.observe(shadowRoot, { childList: true, subtree: true });
    }

    return true;
  };

  const appObserver = new MutationObserver(() => {
    hideTrigger();
  });

  appObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  hideTrigger();
})();
